import { render, staticRenderFns } from "./RecievedChart.vue?vue&type=template&id=b4867172&"
import script from "./RecievedChart.vue?vue&type=script&lang=js&"
export * from "./RecievedChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports